import styles from './loadingComponent.module.scss';

function LoadingComponent() {
	return (
		<div className={styles.loaderContainer}>
			<span className={styles.loader}></span>
		</div>
	);
}

export default LoadingComponent;
